export const manifestLocales = {
  SubmitPageUnansweredQuestions: {
    previewImageAlt: {
      en: 'Unanswered Questions',
      he: 'שאלות שלא נענו'
    }
  }
};
